/** @flow */

export default {
  number: "number",
  string: "string",
  bool: "bool",
  array: "array",
  color: "color",
  object: "object",
  directEvent: "RCTDirectEventBlock",
  bubblingEvent: "RCTBubblingEventBlock"
};
